// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"96":"7b56d01f","101":"a551f930","567":"063a5bde","634":"45361bd3","752":"b2279697"}[chunkId] + ".css";
};